import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';

export interface UserAuthSliceState {
  accessToken: string | null;
}

const initialState: UserAuthSliceState = {
  accessToken: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    setAccessToken: (state, action: PayloadAction<UserAuthSliceState['accessToken']>) => {
      state.accessToken = action.payload;
    },
  },
  extraReducers: builder => {},
});

export const { setAccessToken } = userSlice.actions;

export const selectUser = (state: RootState): UserAuthSliceState => state.user;
export const selectAccessToken = (state: RootState): UserAuthSliceState['accessToken'] => state.user.accessToken;

export default userSlice;
